import { DEFAULT_FEATURES, OnboardLayoutProps } from "@components/layouts/Onboarding/types/props";
import { OnboardingBottomBar } from "@components/utils/OnboardingBottomBar";
import { ButtonIcon, DrawerTitle, DrawerTitleClasses } from "kz-ui-sdk";
import { ReactNode } from "react";
import { MdArrowBack, MdClose } from "react-icons/md";

interface OnboardDialogDrawerLayoutProps extends OnboardLayoutProps {
  titleClasses?: DrawerTitleClasses["classes"];
  subTitle?: ReactNode;
}

const OnboardDialogDrawerLayout = ({
  title,
  subTitle,
  features: userFeatures,
  navigation = {},
  children,
  titleClasses,
}: OnboardDialogDrawerLayoutProps) => {
  const features = { ...DEFAULT_FEATURES, ...userFeatures };

  const shouldShowBackButton = features.showBackButton && (navigation.back?.url || navigation.back?.onClick);
  const shouldShowCloseButton = features.showCloseButton && (navigation.close?.url || navigation.close?.onClick);

  return (
    <div className="relative z-[51] animate-fade-in">
      <DrawerTitle
        title={title}
        subTitle={subTitle}
        backButton={
          shouldShowBackButton ? (
            <ButtonIcon
              className="animate-fade-in"
              onClick={navigation.back?.onClick}
              icon={<MdArrowBack size={24} />}
              variant="ghost"
            />
          ) : null
        }
        classes={{
          "backButtonWrapper&": "-top-1",
          ...titleClasses,
        }}
        closeButton={
          shouldShowCloseButton ? (
            <MdClose
              size={24}
              className="cursor-pointer"
              onClick={navigation.close?.onClick}
            />
          ) : null
        }
      />
      {children}
      <OnboardingBottomBar
        showChatButton={features.showChatButton}
        showLanguageSelect={features.showLanguageSelect}
        className="mb-0"
      />
    </div>
  );
};

export default OnboardDialogDrawerLayout;
